import * as React from 'react';

interface ISliderProps {
    checked: boolean;
    disabled?: boolean;
    onChange: (value) => void;
}

const Slider = (props: ISliderProps): JSX.Element => {
    const { checked, onChange, disabled } = props;
    return (
        <label className={`nexxt-slider ${disabled && 'isDisabled'}`}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(event) => {
                    onChange(event.target.checked);
                }}
            />
            <div>
                <span></span>
            </div>
        </label>
    );
};
export default Slider;
